import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterDropdownContentListItemLabel = function (props) {
    var label = props.label, groupId = props.groupId, itemId = props.itemId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-dropdown-content-list-item-label-v2", { ref: ref, label: label, "group-id": groupId, "item-id": itemId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterDropdownContentListItemLabel;
